import {preload} from 'react-dom';

import {getAssetUrl} from 'coreUtils/utils';

import casadeiSansMedium from 'brandSCSS/fonts/WorkSans-Medium.woff2';
import casadeiSansRegular from 'brandSCSS/fonts/WorkSans-Regular.woff2';

// Above the fold on every page (`--font-medium`, `--font-regular`). Lora (`--font-secondary`) is only in some CMS
// texts: loaded by its `@font-face` when used.
const fonts = [casadeiSansMedium, casadeiSansRegular];

/**
 * Preloads the fonts of the first paint (`<link rel="preload">` in the server `<head>`), so that the text does not
 * swap fonts (and move) once the CSS is parsed.
 */
const FontsPreload = () => {
	fonts.forEach((font) => preload(getAssetUrl(font), {as: 'font', type: 'font/woff2', crossOrigin: 'anonymous'}));

	return null;
};

export default FontsPreload;
